import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/plot/sparklines/base';
import __var_2__ from '@stdlib/plot/sparklines/unicode';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace ns
*/
var ns = {};

/**
* @name base
* @memberof ns
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/plot/sparklines/base}
*/
setReadOnly( ns, 'base', __var_1__);

/**
* @name unicode
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/plot/sparklines/unicode}
*/
setReadOnly( ns, 'unicode', __var_2__);


// EXPORTS //
export default ns;

export { __var_1__ as base, __var_2__ as unicode};